<div class="text-center">
  <h1 class="h5 text-uppercase">{{ 'auth.password.forgot.heading' | translate }}</h1>
</div>

<div class="row mt-2">
  <app-form-group
    [formControl]="form.controls.email"
    type="email"
    name="email"
    label="{{ 'auth.password.forgot.form.email.label' | translate }}"
    [errorMessages]="{
      required: ('auth.password.forgot.form.email.validation_messages.required' | translate),
      email: ('auth.password.forgot.form.email.validation_messages.email' | translate)
    }"
  ></app-form-group>
</div>

<div class="row mt-3">
  <div class="col-12">
    <button (click)="submit()" type="submit" class="btn btn-primary w-100">{{ 'auth.password.forgot.submit_btn' | translate }}</button>
  </div>
</div>

<div class="row mt-2">
  <div class="col-12 justify-content-center d-flex">
    <a class="btn" routerLink="/auth/login">{{ 'auth.password.forgot.cancel_btn' | translate }}</a>
  </div>
</div>
